import {FC, memo} from 'react';
import {api, hasValue, IAttachmentData} from '@kcast-fe/core';
import {Box, Flex, Grid} from '@chakra-ui/react';
import {Svg} from 'ui-kit';
import {docsUtils} from 'core';
import FileSaver from 'file-saver';

interface IProps {
  isMyMsg: boolean;
  files: Array<IAttachmentData>;
}

const RenderFileListFC: FC<IProps> = ({isMyMsg, files}) => {
  const downloadMutation = api.documents.useDocumentDownloadMutation();

  const handleDownload = (attachment: IAttachmentData) => {
    if (hasValue(attachment.id) && hasValue(attachment.name)) {
      downloadMutation.mutate(attachment.id, {
        onSuccess: (resp) => {
          FileSaver.saveAs(new Blob([resp]), attachment.name);
        },
        onError: () => {
          console.error('[File] Download error');
        }
      });
    }
  };

  return (
    <Box
      w={'fit-content'}
      p={'10px 16px'}
      position={'relative'}
      borderRadius={'24px'}
      lineHeight={{base: '24px'}}
      border={!isMyMsg ? undefined : 'thin solid'}
      borderColor={!isMyMsg ? undefined : '{colors.borderDefault}'}
      color={'{colors.textPrimary}'}
      bg={isMyMsg ? '{colors.bgSurface}' : 'white'}
      shadow={isMyMsg ? '{shadows.msg_2}' : '{shadows.msg_1}'}
    >
      <Flex flexDirection={'column'} gap={'10px'}>
        {files.map((attachment) => (
          <Grid
            gap={'8px'}
            key={attachment.url}
            alignItems={'center'}
            gridTemplateColumns={'20px auto'}
            _hover={{cursor: 'pointer', opacity: 0.8}}
            onClick={() => handleDownload(attachment)}
            data-testid={'attached-file'}
          >
            <Svg name={docsUtils.getSvgIconByExtension(attachment.name)} size={'s20'} />
            <Box className={'cut-text'}>{attachment.name}</Box>
          </Grid>
        ))}
      </Flex>
    </Box>
  );
};

export const RenderFileList = memo(RenderFileListFC);
